import { render, staticRenderFns } from "./IstanzaForm.vue?vue&type=template&id=cdfa2ae8&"
import script from "./IstanzaForm.vue?vue&type=script&lang=js&"
export * from "./IstanzaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IstanzaForm.vue"
export default component.exports